import {
  WorkspaceMembersApi,
  type WorkspaceMemberWithUserDto,
} from '@up2stay/up2promo-api-client';

import {
  LIST_FETCH_ALL_MAX_PAGES,
  LIST_PAGE_HARD_CAP,
} from '@/core/lib/list-pagination';

/**
 * Loads every workspace member row by paging `findAll` until the last partial page.
 * Needed because the API caps `limit` at 100 — a single request cannot load larger teams.
 */
export async function fetchAllWorkspaceMembersPages(
  workspaceId: string,
): Promise<WorkspaceMemberWithUserDto[]> {
  const byUserId = new Map<string, WorkspaceMemberWithUserDto>();

  for (let page = 1; page <= LIST_FETCH_ALL_MAX_PAGES; page += 1) {
    const response = await WorkspaceMembersApi.findAll({
      path: { workspaceId },
      query: { page, limit: LIST_PAGE_HARD_CAP },
    });

    const batch = response.data?.data ?? [];
    for (const m of batch) {
      const uid = m.userId?.trim();
      if (uid) byUserId.set(uid, m);
    }
    if (batch.length === 0 || batch.length < LIST_PAGE_HARD_CAP) {
      break;
    }
  }

  return [...byUserId.values()];
}
